import React, { useRef, useState, useEffect, useCallback } from "react";
import { Button } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import { GoogleSignIn } from "../GoogleAuthentication";
import { CurrentUser } from "../../bitmaker";

interface Props {
  user?: CurrentUser;
  loginSuccess: (expiresIn: number) => void;
  logoutSuccess: () => void;
}

const UserCardComponent: React.FC<Props> = (props) => {
  const [clickedCard, setClickedCard] = useState(false);

  const cardRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const navigate = useNavigate();

  const handleClickOutside = useCallback((event: MouseEvent) => {
    if (
      cardRef.current &&
      !cardRef.current.contains(event.target as Node) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target as Node)
    ) {
      setClickedCard(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);

  const clickCard = () => {
    setClickedCard((prev) => !prev);
  };

  const handleLogout = () => {
    props.logoutSuccess();
    navigate("/");
    setClickedCard(false);
  };

  const renderClickCard = () => {
    const { user } = props;

    if (!user || !user.profile) return null;

    return (
      <div
        ref={cardRef}
        className="absolute top-0 right-0 mt-16 mr-1 p-6 bg-white rounded-lg shadow-xl z-10 text-center"
      >
        <div className="p-2">
          <div className="px-4">
            <img
              src={user.profile.google_image_url}
              alt="avatar"
              className="user-card-image mx-auto mb-4"
            />

            <div className="font-semibold">
              {user.profile.google_given_name} {user.profile.google_family_name}
            </div>

            <div className="text-sm text-gray-600 mb-4">
              {user.profile.google_email}
            </div>
          </div>

          <Button
            icon={<LogoutOutlined />}
            onClick={handleLogout}
            className="flex items-center justify-center w-full"
          >
            Log out
          </Button>
        </div>
      </div>
    );
  };

  return (
    <div>
      {props.user ? (
        <div className={"user-card-container"}>
          <div className={"user-card-image"}>
            <button ref={buttonRef} onClick={clickCard}>
              <img src={props.user.profile!.google_image_url} alt={"avatar"} />
            </button>
            {clickedCard && renderClickCard()}
          </div>
        </div>
      ) : (
        <GoogleSignIn loginSuccess={props.loginSuccess} />
      )}
    </div>
  );
};

export const UserCard = UserCardComponent;
